import { Modal } from 'bootstrap';
import BaseComponent from '../../../../../common/js/BaseComponent';
import Helper from '../../../../../common/utils/helper';

export default class Favorite extends BaseComponent {
    wishlistModalElement: HTMLElement | null;

    wishlistModalInstance: Modal | null;

    toggleUrl: string | null;

    getSelectorChooseWishlist(): HTMLSelectElement | null {
        return this.wishlistModalElement?.querySelector('#choose-wishlist-selector') ?? null;
    }

    getBtnCreateWishlist(): HTMLButtonElement | null {
        return this.wishlistModalElement?.querySelector('#createWishlist') ?? null;
    }

    getBtnAddFavorite(): HTMLButtonElement | null {
        return this.wishlistModalElement?.querySelector('#addFavorite') ?? null;
    }

    init():void {
        this.initEvents();
    }

    initEvents() {
        this.initAddToFav();
    }

    initAddToFav() {
        const btn = this.view.querySelector('.heart') as HTMLButtonElement;
        if (btn) {
            btn.addEventListener('click', () => {
                this.toggleFav(btn);
            });
        }
    }

    initCreateModalEvents() {
        this.addFavoriteEvent();
        this.chooseWishlistEvents();
        this.createWishlistEvents();
    }

    initModalDisplayEvents() {
        // On initialise les evts d'affichage/masquage
        this.onCreateModalShow();
        this.onCreateModalHide();
    }

    emptyHeart() {
        const btn = this.view.querySelector('.heart') as HTMLButtonElement;
        Helper.replaceClass(btn.querySelector('.checked') as HTMLElement, 'd-block', 'd-none');
        Helper.replaceClass(btn.querySelector('.unchecked') as HTMLElement, 'd-none', 'd-block');
    }

    fillHeart() {
        const btn = this.view.querySelector('.heart') as HTMLButtonElement;
        Helper.replaceClass(btn.querySelector('.checked') as HTMLElement, 'd-none', 'd-block');
        Helper.replaceClass(btn.querySelector('.unchecked') as HTMLElement, 'd-block', 'd-none');
    }

    private onCreateModalShow() {
        if (this.wishlistModalElement != null) {
            this.wishlistModalElement.addEventListener('show.bs.modal', () => {
                this.initCreateModalEvents();
            });
        }
    }

    private onCreateModalHide() {
        if (this.wishlistModalElement != null) {
            this.wishlistModalElement.addEventListener('hidden.bs.modal', () => {
                this.wishlistModalElement?.remove();
                this.wishlistModalElement = null;
            });
        }
    }

    private toggleFav(button: HTMLButtonElement): void {
        const url = button.getAttribute('data-url');
        // On vérifie que j'ai bien une url
        if (url != null && url !== '') {
            // On vérifie que l'on est connecté
            if (document.body.getAttribute('data-auth') === 'true') {
                // on stock l'url du produit sur lequel on veut gérer le fav
                this.toggleUrl = url;
                // on va chercher ma modale avec la liste des projets
                this.displayWishlistModal();
            }
        }
    }

    private displayWishlistModal() {
        return fetch('/mon-espace/chooseWishlist', {
            method: 'POST',
            headers: Helper.createFetchHeader(),
            body: JSON.stringify({
                product: this.view.getAttribute('data-product'),
            }),
        })
            .then((response) => Promise.all([response, response.text()]))
            .then(([, data]) => {
                this.createModal(data);
            });
    }

    private createModal(data: string) {
        // On inject ma modal dans mon DOM
        document.body.insertAdjacentHTML('beforeend', data);

        // On va récupérer la modal précédement injectée
        this.wishlistModalElement = document.getElementById('modalChooseWishlist');
        // On vérifie que la modal existe bien
        if (this.wishlistModalElement) {
            this.initModalDisplayEvents();

            // On affiche ma modale
            this.wishlistModalInstance = window.bootstrap.Modal.getOrCreateInstance(this.wishlistModalElement);
            this.wishlistModalInstance.show();
        }
    }

    private addFavoriteEvent() {
        // Click sur le boutton Ajouter au projet
        const btnAddFavorite = this.wishlistModalElement?.querySelector('#addFavorite');
        const form = this.wishlistModalElement?.querySelector('form');
        if (btnAddFavorite) {
            btnAddFavorite.addEventListener('click', (e) => {
                // On va vérifier que les champs requis sont remplis
                const isFormValid = form?.checkValidity();
                if (!isFormValid) {
                    form?.reportValidity();
                } else {
                    e.preventDefault();
                    // Si le formulaire est valide on le soumet
                    this.updateStatus();
                }
            });
        }
    }

    private chooseWishlistEvents() {
        // Click sur le boutton de création de nouveau projet
        const selectChooseWishlist = this.getSelectorChooseWishlist();
        const btnAddFavorite = this.getBtnAddFavorite();
        const inWishlistElement = this.wishlistModalElement?.querySelector('input[name="inWishlists"]') as HTMLInputElement;
        const inWishlist = JSON.parse(inWishlistElement.value) ?? null;
        if (selectChooseWishlist) {
            selectChooseWishlist.addEventListener('change', () => {
                // On va changer l'intitulé du btn d'ajout
                if (btnAddFavorite) {
                    // On vérifie si le produit est présent dans la wishlist sélectionné
                    if (selectChooseWishlist.value != null && selectChooseWishlist.value !== '' && inWishlist != null && inWishlist.includes(parseInt(selectChooseWishlist.value, 10))) {
                        btnAddFavorite.innerText = btnAddFavorite?.getAttribute('data-remove') ?? '';
                    } else {
                        btnAddFavorite.innerText = btnAddFavorite?.getAttribute('data-add') ?? '';
                    }
                }
            });
        }
    }

    private createWishlistEvents() {
        // Click sur le boutton de création de nouveau projet
        const btnAddWishlist = this.getBtnCreateWishlist();
        const btnAddFavorite = this.getBtnAddFavorite();
        if (btnAddWishlist) {
            btnAddWishlist.addEventListener('click', () => {
                // Changer le libéler du btn
                if (btnAddWishlist.innerText === btnAddWishlist.getAttribute('data-cancel')) {
                    btnAddWishlist.innerText = btnAddWishlist.getAttribute('data-create') ?? '';
                } else {
                    btnAddWishlist.innerText = btnAddWishlist.getAttribute('data-cancel') ?? '';
                }
                // Enlever/rajouter required sur le select
                const select = this.getSelectorChooseWishlist();
                if (select) {
                    if (select.hasAttribute('required')) {
                        select.selectedIndex = 0;
                        select.removeAttribute('required');
                        select.setAttribute('disabled', 'disabled');
                        if (btnAddFavorite) {
                            btnAddFavorite.innerText = btnAddFavorite?.getAttribute('data-add') ?? '';
                        }
                    } else {
                        select.removeAttribute('disabled');
                        select.setAttribute('required', 'required');
                    }
                }
                // Ajouter/Supprimer le required sur les inputs
                this.wishlistModalElement?.querySelectorAll('#collapseNewWishlist input').forEach((input:HTMLInputElement) => {
                    if (input.hasAttribute('required')) {
                        input.value = '';
                        input.removeAttribute('required');
                        input.setAttribute('disabled', 'disabled');
                    } else {
                        input.removeAttribute('disabled');
                        // on ne rajoute pas de required sur le champs commentaire
                        if (input.getAttribute('name') !== 'comment') {
                            input.setAttribute('required', 'required');
                        }
                    }
                });
            });
        }
    }

    private updateStatus() {
        const form = this.wishlistModalElement?.querySelector('form');
        if (form) {
            const formData = new FormData(form);
            return fetch(this.toggleUrl ?? '/', {
                method: 'POST',
                body: formData,
                headers: Helper.createFetchHeaderWithoutContentType(),
            })
                .then((response) => Promise.all([response, response.json()]))
                .then(([response, data]) => {
                    if (!response.ok) {
                        throw new Error(data.message ?? '');
                    }
                    // On masque la modale d'ajout
                    this.wishlistModalInstance?.hide();
                    // Dans le cas ou l'on a un message
                    if (data.message) {
                        Helper.createToastElement(data.message, 'success');
                    }
                    // On remplis / vide notre coeur.
                    if (data.filled === true) {
                        this.fillHeart();
                    } else {
                        this.emptyHeart();
                    }
                    // On ferme la modale
                })
                .catch((error) => {
                    // @TODO
                    console.error('Error:', error);
                });
        }
        return null;
    }
}
